import {ToastArea as ToastAreaBase} from '@prtimes-basis/toast-area';
import type {Toast} from '@prtimes-basis/toast-area/toast';
import {useCallback, type ComponentProps} from 'react';
import {useRecoilState} from 'recoil';
import {toastListState} from '@/states/toast-list';
import {TOAST_LIFE} from '@/constants';

export function ToastArea() {
  const [toastList, setToastList] = useRecoilState(toastListState);

  const removeToastItem = useCallback(
    (id: number) => {
      setToastList((previous) => previous.filter((item) => item.id !== id));
    },
    [setToastList],
  );

  const handleAnimationComplete = useCallback(
    (id: number, variant: ComponentProps<typeof Toast>['variant']) => {
      const toastLife = TOAST_LIFE[variant];

      setTimeout(() => {
        removeToastItem(id);
      }, toastLife * 1000);
    },
    [removeToastItem],
  );

  return (
    <ToastAreaBase
      toastList={toastList}
      handleAnimationComplete={handleAnimationComplete}
      removeToastItem={removeToastItem}
    />
  );
}
